// TODO: remove when getting rid of <NativeModal>

const CONTAINER_ID = 'overlay-root'

let container: HTMLElement | null = null
let styleInjected = false

const injectStyle = () => {
  if (styleInjected) {
    return
  }
  const style = document.createElement('style')
  style.textContent = `#${CONTAINER_ID} > * { isolation: isolate; }`
  document.head.appendChild(style)
  styleInjected = true
}

export const getOverlayContainer = () => {
  if (typeof document === 'undefined') {
    return null
  }

  if (!container || !document.body.contains(container)) {
    container = document.getElementById(CONTAINER_ID)
    if (!container) {
      container = document.createElement('div')
      container.id = CONTAINER_ID
      document.body.appendChild(container)
    }
    injectStyle()
  }

  return container
}
